(function () {
  function reveal(root) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.2 });
    root.querySelectorAll('[data-mc-reveal]').forEach(function (el) {
      el.setAttribute('data-js', '');
      observer.observe(el);
    });
  }

  function trust(root) {
    root.querySelectorAll('[data-trust]').forEach(function (badge) {
      badge.addEventListener('click', function (e) {
        var details = document.querySelector('.mc-acc-item');
        if (!details || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        details.open = true;
        details.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });
  }

  function installments(root) {
    var label = root.querySelector('[data-installment]');
    var pricesEl = root.querySelector('[data-prices]');
    var formatEl = root.querySelector('[data-money-format]');
    var section = document.querySelector('.product__section');
    if (!label || !pricesEl || !formatEl || !section) return;
    var prices = JSON.parse(pricesEl.textContent);
    var format = JSON.parse(formatEl.textContent);
    var parts = Number(label.dataset.parts);
    section.addEventListener('change', function () {
      if (!label.isConnected) return;
      setTimeout(function () {
        var input = section.querySelector('input.formVariantId');
        var price = input && prices[input.value];
        if (!price) return;
        var amount = (Math.ceil(price / parts) / 100).toFixed(2);
        label.textContent = parts + ' cuotas de ' + format.replace(/\{\{\s*\w+\s*\}\}/, amount);
      }, 120);
    });
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    reveal(root);
    trust(root);
    installments(root);
  }

  document.querySelectorAll('[data-product-extras]').forEach(init);

  // Personalizador: al volver a generarse la sección, coloca el contenido nuevo y quita el anterior.
  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    var fresh = e.target.querySelector('[data-product-extras]');
    var buttons = document.querySelector('.product__section--buttons');
    if (fresh && buttons) {
      document.querySelectorAll('[data-product-extras]').forEach(function (el) {
        if (el !== fresh && el.dataset.section === id) el.remove();
      });
      buttons.insertAdjacentElement('afterend', fresh);
    }
    document.querySelectorAll('[data-product-extras]').forEach(init);
  });
})();